<template>

    <div class="filter"> 
        <Select v-model="clientInput"
            :options="clientOptions"
            :all="(all) ? 'Tous les clients' : ''"
            autocomplete>
        </Select>
    </div>

</template>

<script>
import { FILTER_EVENT, FilterBus } from './Filter.vue'
import Select  from '@/components/select/Select.vue'

export default {

    props: {
        
        all: {
            type: Boolean,
            default: true
        },
        
        clients: {
            type: Array,
            default: () => []
        },

        value: {
            default: null
        }
    },

    computed: {

        clientInput: {

            get: function(){
                return this.value;
            },

            set: function(value) {
                this.$emit('input', value)
                FilterBus.$emit(FILTER_EVENT, {
                    criteria: 'client_id',
                    value: value
                })
            }
        },

        clientOptions: function() {
            let clientOptions = []
            if (this.clients) {
                this.clients.forEach(client => {
                    clientOptions.push({
                        value: client.id,
                        name: client.label
                    })
                })
            }
            return clientOptions
        }
    },

    components: {
        Select
    }
}

</script>

<style scoped>

@media screen and (min-width: 800px) {

    .select {
        min-width: 25rem;
    }
}

</style>